import { useCallback } from "react";
import { useAccordionContext } from "../Accordion";
import { ariaAttributes, dataAttributes } from "../../../utils/dom";

export function useAccordionItem(props) {
  const { index, isDisabled, ...htmlProps } = props;
  const { activeItems, backgroundStyle, handleItemClick } =
    useAccordionContext();

  const isOpen = Array.isArray(activeItems)
    ? activeItems.includes(index) && !isDisabled
    : activeItems === index && !isDisabled;

  const getAccordionItemProps = useCallback(
    (passedProps = {}) => ({
      ...passedProps,
      "aria-expanded": ariaAttributes(isOpen),
      "data-disabled": dataAttributes(props.isDisabled),
    }),
    [isOpen, props.isDisabled]
  );

  const getAccordionHeaderProps = useCallback(
    (passedProps = {}) => ({
      ...passedProps,
      "data-disabled": dataAttributes(props.isDisabled),
      disabled: props.isDisabled,
      onClick: () => handleItemClick(index),
    }),
    [handleItemClick, index, props.isDisabled]
  );

  return {
    backgroundStyle,
    getAccordionHeaderProps,
    getAccordionItemProps,
    htmlProps,
    isDisabled,
    isOpen,
  };
}
